import React from 'react'
import styled from 'styled-components'
import video from '../../Images/lol.mp4'
import silly from '../../Images/wordle.jpg'
import electron from '../../Images/electron.mp4'



export default function Me() {
    return (
        <Container>  
            <Box>
            <h1>blog</h1>

            <br/>
            02/28/25<br/><br/>

            <video src={electron} controls autoplay loop muted playsinline width="400px"/>

            <p>
            Created my first Electron desktop application! It's an app used to modify a player's username, twitter account, pronouns etc. for use with OBS and Fighting Games.
            </p>

            <br/>
            02/26/25<br/><br/>

            <img src={silly} alt="blah"/>

            <p>
            I created a React App based on Wordle. Check it out, <a href="https://4nbawordle.netlify.app/">here</a><br/>
           
            </p>
        
         
            
            <br/>
            02/17/25<br/><br/>

            <video src={video} controls autoplay loop muted playsinline width="400px"/>
        
            <p>
            Working on animating!
            </p>
            </Box>
        </Container>
    )
}

const Container = styled.div`
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
@media only screen and (min-width: 600px) {
    margin-left:20%;
    margin-right:20%;
`

const Box = styled.div`
width:400px;
margin-top:20px;
margin-bottom:20px;
`
